var currency = require( '../global/currency' );

var product_single = (function ( $ ) {

	var _init = function () {
		$( '.variations_form' ).on( 'show_variation', _change_variation );
	};

	var _change_variation = function() {
		currency.refresh_prices_currency();
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = product_single;